import { render, staticRenderFns } from "./DoctorSpecialist.vue?vue&type=template&id=b5f049f0&"
import script from "./DoctorSpecialist.vue?vue&type=script&lang=js&"
export * from "./DoctorSpecialist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports